import React, { Component } from 'react';

export class Navigation extends Component {
    render() {
        return (
            <div className="navigation-wrapper">
                <div><img src="/assets/images/ic-home.svg" className="ic-home" alt="home icon" /></div>
                {this.props.pathName.map((path, i) => {
                    return (
                        <React.Fragment key={i}>
                            <div><img src="/assets/images/ic-clamp.svg" className="ic-clamp" alt="clamp icon" /></div>
                            <div className="navi-text">{path}</div>
                        </React.Fragment>
                    );
                })
                }
            </div>
        );
    }
}